<template>
    <svg class="livrero-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <defs>
            <linearGradient id="livrero-underline" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style="stop-color: #eab308" />
                <stop offset="100%" style="stop-color: #facc15" />
            </linearGradient>
        </defs>
        <text
            x="4"
            y="34"
            font-family="system-ui, -apple-system, BlinkMacSystemFont, sans-serif"
            font-size="36"
            font-weight="700"
            class="livrero-text"
        >
            L
        </text>
        <rect x="4" y="38" width="24" height="5" rx="2.5" fill="url(#livrero-underline)" />
    </svg>
</template>

<style>
.livrero-icon .livrero-text {
    fill: currentColor;
}
</style>
